import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { useDeleteClasses } from 'queryHooks/Organization/Classes/useDeleteClasses';

type Props = {
  isOpen: boolean;
  close: () => void;
  selectedIds: string[];
};

export const DeleteClassesModal = ({ isOpen, close, selectedIds }: Props) => {
  const { t } = useTranslation();
  const notificationsStore = useStores().notificationStore;
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  const deleteClasses = useDeleteClasses(selectedOrganizationId);

  const confirm = () =>
    deleteClasses.mutate(selectedIds, {
      onSuccess: ({ succeeded, failed, total }) => {
        if (total === 1) {
          if (failed === 0) {
            notificationsStore.addToast('success', t('ClassDeleted', { ns: 'classPage' }), 'success');
          } else if (succeeded === 0) {
            notificationsStore.addToast('error', t('DeleteClassError', { ns: 'classPage' }), 'error');
          }
        } else {
          if (failed === 0) {
            notificationsStore.addToast('success', t('ClassesDeleted', { ns: 'classPage' }), 'success');
          } else if (succeeded === 0) {
            notificationsStore.addToast('error', t('DeleteClassError', { ns: 'classPage' }), 'error');
          } else {
            notificationsStore.addToast('warning', t('DeleteClassPartial', { ns: 'classPage', succeeded }), 'info');
          }
        }

        close();
      },
    });

  return (
    <Modal
      open={isOpen}
      onClose={close}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => close(),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Delete', { ns: 'studentsPage' }),
        onClick: () => confirm(),
      }}
      title={t('DeleteClass', { ns: 'classPage' })}
      titleIcon={<TrashIcon />}
      aria-labelledby={t('DeleteClass', { ns: 'classPage' })}
      aria-describedby={t('DeleteClassFromTheList', { ns: 'classPage' })}
    >
      <div className='modal-body'>
        <Paragraph>
          <>
            {selectedIds.length === 1
              ? t('AreYouSureYouWantPermanentlyDeleteThisClass', { ns: 'classPage' })
              : t('AreYouSureYouWantPermanentlyDeleteTheseClasses', { ns: 'classPage' })}
          </>
        </Paragraph>
      </div>
    </Modal>
  );
};

export default DeleteClassesModal;
